<template>
  <div class="side-wrapper">
    <!-- Header -->
    <div class="side-header">
      <h1>{{ $gettext("Organization") }}</h1>
    </div>

    <!-- Body -->
    <div class="side-body">
      <pre>{{ props.data }}</pre>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();
const props = defineProps({
  data: {
    type: Object,
    required: false,
  },
});
</script>
